import BaseLevelScene from './BaseLevelScene';

export default class VCUEngineeringScene extends BaseLevelScene {
  tileWidth: integer = 16;
  tileHeight: integer = 16;
  constructor() {
    super('VCU Engineering Building');
  }

  preload() {

    // Preload base level
    this.preloadBaseLevel();

    // load lab floor PNG file
    this.load.image('floor_tiles', 'assets/sourceImages/tilesFloor32.png');

    // load lab walls PNG file
    this.load.image('wall_tiles', 'assets/sourceImages/tilesWalls.png')

    // load lab stuff PNG file
    this.load.image('stuff_tiles', 'assets/sourceImages/tilesStuff.png')

    // load the JSON map
    this.load.tilemapTiledJSON(
      'mad_lab_tilemap',
      'assets/scenes/MadLab.json'
    );
  }

  create() {
    // 👌 sanity check by displaying the entire tileset image
    // this.add.image(0, 0, 'sewer_tiles');

    // create the Tilemap
    this.map = this.make.tilemap({ key: 'mad_lab_tilemap' });

    // add the tileset  images we are using
    const floorTileset = this.map.addTilesetImage('LabFloor', 'floor_tiles');
    const wallTileset = this.map.addTilesetImage('LabWalls', 'wall_tiles');
    const stuffTileset = this.map.addTilesetImage('LabStuff', 'stuff_tiles');

    // create the layers we want in the right order
    const floor = this.map.createLayer('Floor', floorTileset);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(floor);

    // add walls over the floor layer
    const walls = this.map.createLayer('Walls', wallTileset);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(walls);

    // add furniture over the walls layer
    const furniture = this.map.createLayer('Furniture', stuffTileset);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(furniture);

    // add stuff over the furniture layer
    const stuff = this.map.createLayer('Stuff', stuffTileset);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(stuff);

    // create base level
    this.createBaseLevel(1, 1.5);
  }
}
